 import Vue from 'vue'
import Vuelidate from 'vuelidate'
import Paginate from 'vuejs-paginate'
import VueMeta from 'vue-meta'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import dateFilter from '@/filters/date.filter'
import currencyFilter from '@/filters/currency.filter'
import localizeFilter from '@/filters/localize.filter'
import tooltipDirective from '@/derectives/tooltip.directive'
import messagePlagin from '@/utils/message.plagin.js'
import titlePlagin from '@/utils/title.plagin.js'
import Loader from '@/components/app/Loader'
import 'materialize-css/dist/js/materialize.min.js';

import firebase from 'firebase/app'
import 'firebase/auth' 
import 'firebase/database'


Vue.config.productionTip = false

Vue.use(messagePlagin)
Vue.use(titlePlagin)
Vue.use(Vuelidate)  
Vue.use(VueMeta)
Vue.filter('date', dateFilter)
Vue.filter('localize', localizeFilter)
Vue.filter('currency', currencyFilter)
Vue.directive('tooltip', tooltipDirective)
//глобальная регистарция дерективы, второй парам ее значение, первый парам ее название или айди (придумали)
//чтобы глобально зарегить лоадер. название комп и передача лоудера
Vue.component('Loader', Loader)
Vue.component('Paginate', Paginate)
 

firebase.initializeApp({
	 apiKey: "AIzaSyAybSoGu-ekFYn6k29CCVxP42X6V2FAEW8",
    authDomain: "vue-p10.firebaseapp.com",
    databaseURL: "https://vue-p10.firebaseio.com",
    projectId: "vue-p10",
    storageBucket: "vue-p10.appspot.com",
    messagingSenderId: "350626090232",
    appId: "1:350626090232:web:fdb43a0db3a01a95b2ff0d",
    measurementId: "G-KKXQ5XCPWY"
}) 
  

let app

firebase.auth().onAuthStateChanged(()=>{
	if(!app){
		 

app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

 }
})
 

 
 